import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Crown, LayoutDashboard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboardTarget } from '@/hooks/useDashboardTarget';

// Final conversion band. Reuses the existing VIP gradient treatment so it matches
// the current SoundWolves identity. Logged-out visitors are invited to sign up;
// authenticated visitors get a dashboard shortcut instead of a redundant "sign up".
export function JoinCtaBanner() {
  const { isAuthenticated } = useAuth();
  const dashboardTo = useDashboardTarget();

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 gradient-vip opacity-50" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <img
            src="/logo.png"
            alt="SoundWolves Logo"
            className="h-20 mx-auto mb-6 object-contain animate-glow"
          />
          {isAuthenticated ? (
            <>
              <h2 className="text-4xl sm:text-5xl font-display font-bold mb-4">
                Welcome back to the <span className="text-gradient-gold">pack</span>
              </h2>
              <p className="text-lg text-muted-foreground mb-8">
                Jump back into your events, tickets, and updates.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to={dashboardTo}>
                  <Button variant="premium" size="lg">
                    <LayoutDashboard className="w-5 h-5 mr-2" />
                    Go to Dashboard
                  </Button>
                </Link>
                <Link to="/membership">
                  <Button variant="outline" size="lg">
                    <Crown className="w-5 h-5 mr-2" />
                    Wolves Pass
                  </Button>
                </Link>
              </div>
            </>
          ) : (
            <>
              <h2 className="text-4xl sm:text-5xl font-display font-bold mb-4">
                Join <span className="text-gradient-gold">SoundWolves</span>
              </h2>
              <p className="text-lg text-muted-foreground mb-8">
                Join SoundWolves to manage events, tickets, and updates.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/login">
                  <Button variant="premium" size="lg">
                    <Sparkles className="w-5 h-5 mr-2" />
                    Join SoundWolves
                  </Button>
                </Link>
                <Link to="/membership">
                  <Button variant="outline" size="lg">
                    <Crown className="w-5 h-5 mr-2" />
                    Wolves Pass
                  </Button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default JoinCtaBanner;
